import { createContext, useEffect, useState } from "react";
import { loginUser, refreshToken } from "../business/UserBusiness";
import api from "../services/api";

export const AuthContext = createContext()

const AUTH_KEYS = ["@Auth:token", "@Auth:user", "@Auth:Id", "@Auth:name", "@Auth:isAdmin"];

const readStoredSession = () => {
    try {
        const user = JSON.parse(localStorage.getItem("@Auth:user"));
        if (!user || !localStorage.getItem("@Auth:token") || !localStorage.getItem("@Auth:name")) return null;
        return { user, isAdmin: localStorage.getItem("@Auth:isAdmin") === 'true' };
    } catch {
        return null;
    }
};

export const AuthProvider = ({children}) => {

    // Sessão salva lida já no primeiro render: lida num efeito, o painel achava que ninguém estava
    // logado, mandava pro login e de lá pra Usuários (recarregar qualquer tela caía em Usuários)
    const [user, setUser] = useState(() => readStoredSession()?.user || null)
    const [customer, setCustomer] = useState(null)
    const [subscription, setSubscription] = useState(null)
    const [selectedClientId, setSelectedClientId] = useState(null);
    const [selectedTaskId, setSelectedTaskId] = useState(null);
    const [isLoading, setIsLoading] = useState(false)
    const [isAdmin, setIsAdmin] = useState(() => readStoredSession()?.isAdmin || false)

    useEffect(() => {
        setSubscription(readStoredSession()?.user?.subscriptionStatus || null);
    }, []);

    const setClient = (id) =>{
        setSelectedClientId(id);
    }

    const setTask = (id) => {
        setSelectedTaskId(id)
    }

    const signIn = async ({email, phone, password, turnstileToken}) => {
        try {
            const credential = email?.trim() || phone?.trim();
            const payload = email?.trim()
                ? { email: credential, password, turnstileToken }
                : { phone: credential, password, turnstileToken };
            const response = await loginUser(payload);
            
            if (response?.data?.error) {
                throw new Error(response.data.error);
            }

            const userData = response?.data?.user;
            const token = response?.data?.token;

            // Verificar se o usuário tem role "admin"
            if (userData?.role !== 'admin') {
                throw new Error('Acesso negado. Apenas administradores podem acessar o painel administrativo.');
            }

            setUser(userData);
            setSubscription(userData?.subscriptionStatus);
            setIsAdmin(true);
            
            // Configurar token no axios
            api.defaults.headers.common['Authorization'] = `Bearer ${token}`;
            
            // Salvar no localStorage
            localStorage.setItem("@Auth:token", JSON.stringify(token));
            localStorage.setItem("@Auth:user", JSON.stringify(userData));
            localStorage.setItem("@Auth:Id", JSON.stringify(userData?.id));
            localStorage.setItem("@Auth:name", userData?.username);
            localStorage.setItem("@Auth:isAdmin", 'true');
            
            console.log("Login realizado com sucesso:", response?.data);
            
        } catch (error) {
            console.error("Erro no login:", error);
            throw error;
        }
    }

    const signOut = () => {
        // Só as chaves do login: a preferência de tema claro/escuro fica
        AUTH_KEYS.forEach((key) => localStorage.removeItem(key))
        setUser(null)
        setSubscription(null)
        setIsAdmin(false)
    }

    return(
        <AuthContext.Provider value={{
            user,
            subscription,
            selectedClientId,
            selectedTaskId,
            signed: !!user,
            isAdmin,
            signIn,
            signOut,
            setClient,
            setTask
        }}>
            {children}
        </AuthContext.Provider>
    )
}